import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link } from 'react-scroll'
import { NavLink } from 'react-router-dom'

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/home_ico',
    },
    {
        id: 2,
        title: 'About',
        link: '/about',
    },
    {
        id: 3,
        title: 'Contact',
        link: '/contact',
    }
]

const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <ul className="mobail-menu main_menu_list unordered_list text-uppercase">
            {menus.map((item, mn) => {
                return (
                    <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                        {item.submenu ?
                            <Fragment>
                                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                </p>
                                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                    <List className="menu-item menu-item-has-children active">
                                        <Fragment>
                                            {item.submenu.map((submenu, i) => {
                                                return (
                                                    <ListItem key={i}>
                                                        <NavLink onClick={ClickHandler} className="active"
                                                            to={submenu.link}>{submenu.title}</NavLink>
                                                    </ListItem>
                                                )
                                            })}
                                        </Fragment>
                                    </List>
                                </Collapse>
                            </Fragment>
                            : <NavLink className="active"
                                to={item.link}>{item.title}</NavLink>
                        }
                    </ListItem>
                )
            })}
            {/* <ul className='MuiList-root MuiList-padding css-h4y409-MuiList-root'>
                <li>
                    <Link to="id_ico_about_section" spy={true} smooth={true} duration={500} offset={-100} className="nav-link scrollspy_btn">
                        <span className="nav_link_label" data-text="About ICO">About ICO</span>
                    </Link>
                </li>
            </ul> */}
            {/* <ul className='MuiList-root MuiList-padding css-h4y409-MuiList-root'>
                <li>
                    <Link to="id_ico_service_section" spy={true} smooth={true} duration={500} offset={-100} className="nav-link scrollspy_btn">
                        <span className="nav_link_label" data-text="Features">Features</span>
                    </Link>
                </li>
            </ul> */}
        </ul>
    )
}

export default MobileMenu;

// import React, { Fragment, useState } from 'react'
// import List from "@mui/material/List"
// import ListItem from "@mui/material/ListItem"
// import Collapse from "@mui/material/Collapse"
// import { Link } from 'react-scroll'
// import { NavLink } from 'react-router-dom'
// import './MobileMenu.css'




// const MobileMenu = ({ navigation }) => {
//   const [openId, setOpenId] = useState(0)

//   const ClickHandler = () => {
//     window.scrollTo(10, 0)
//   }




//   return (
//     <ul className="mobail-menu main_menu_list unordered_list text-uppercase">
//       {navigation?.map((item, index) => (
//         <ListItem
//           className={`menu-item ${item.id === openId ? 'active menu-item-has-children' : ''}`}
//           key={index}
//         >
//           {item.dropdown ? (
//             <Fragment>
//               <p
//                 onClick={() => setOpenId(item.id === openId ? 0 : item.id)}
//                 className="nav-link"
//               >
//                 {item.label}
//                 <i className={`fa ${item.id === openId ? 'fa-angle-up' : 'fa-angle-down'} ms-2`}></i>
//               </p>
//               <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
//                 <List className="submenu unordered_list">
//                   {item.dropdown.map((subItem, subIndex) => (
//                     <ListItem key={subIndex}>
//                       {subItem.type === 'scroll' ? (
//                         <Link
//                           to={subItem.target}
//                           spy={true}
//                           smooth={true}
//                           duration={500}
//                           offset={-100}
//                           className="dropdown-item scrollspy_btn"
//                         >
//                           {subItem.label}
//                         </Link>
//                       ) : (
//                         <NavLink
//                           onClick={ClickHandler}
//                           to={subItem.link || '#'}
//                           className="dropdown-item"
//                         >
//                           {subItem.label}
//                         </NavLink>
//                       )}
//                     </ListItem>
//                   ))}
//                 </List>
//               </Collapse>
//             </Fragment>
//           ) : item.type === 'scroll' ? (
//             <Link
//               to={item.target}
//               spy={true}
//               smooth={true}
//               duration={500}
//               offset={-100}
//               className="nav-link scrollspy_btn"
//             >
//               <span className="nav_link_label" data-text={item.label}>{item.label}</span>
//             </Link>
//           ) : (
//             <NavLink onClick={ClickHandler} to={item.link || '/'} className="nav-link">
//               <span className="nav_link_label" data-text={item.label}>{item.label}</span>
//             </NavLink>
//           )}
//         </ListItem>
//       ))}
//     </ul>
//   )
// }

// export default MobileMenu
